const PURCHASED_CUSTOM_PRINT_STATUS = {
  CUSTOMER_INPUT: 'CUSTOMER_INPUT',
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  SHIPPED: 'SHIPPED',
  CANCELED: 'CANCELED',
};

export { PURCHASED_CUSTOM_PRINT_STATUS };
